import { fromJS } from 'immutable'
import { getWidth } from 'selectors/environment'

import { getNewsUi } from './ui'
import { getNewsGroups, getNewsGroupsSortOrder } from './index'

const calculateNumberOfVisibleGroups = state => {
  const width = getWidth(state)

  if (width <= 900) {
    return 1
  }

  if (width <= 1300) {
    return 2
  }

  if (width <= 1900) {
    return 3
  }

  if (width <= 2300) {
    return 4
  }

  return 5
}

const isVisible = (start, end, i) => (i >= start) && (i <= end)

export const getGroupStatus = state => {
  const newsGroups = getNewsGroups(state)
  const groupSortOrder = getNewsGroupsSortOrder(state)
  const currentIndex = getNewsUi(state).get('currentIndex')

  const single = newsGroups.size === 1
  let i = 0

  let existingGroups = groupSortOrder.map((id, index) => (
    fromJS({
      id,
      index,
      single,
      channelId: newsGroups.getIn([id, 'channelId']),
      name: newsGroups.getIn([id, 'name']),
      showSpinner: newsGroups.getIn([id, 'loadingMore']) || false,
      exhausted: newsGroups.getIn([id, 'exhausted']) || false,
      total: newsGroups.getIn([id, 'stats', 'total']),
      count: newsGroups.getIn([id, 'stats', 'count']),
      reach: newsGroups.getIn([id, 'stats', 'reach']),
      photo: newsGroups.getIn([id, 'photo']),
      interactions: newsGroups.getIn([id, 'stats', 'interactions']),
      newsList: newsGroups.getIn([id, 'news'])
    })
  )).filter(g => g.get('newsList'))

  // add a visibilty info to each channel
  const numberOfVisibleGroups = calculateNumberOfVisibleGroups(state)
  const start = Math.min(currentIndex, existingGroups.size - numberOfVisibleGroups)
  const end = (start + numberOfVisibleGroups) - 1
  for (i = 0; i < existingGroups.size; i += 1) {
    existingGroups = existingGroups.setIn([i, 'visible'], isVisible(start, end, i))
  }

  return existingGroups
}
